import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export type ProcurementStepRow = {
  id?: number;
  name: string;
  lead_time_weeks: number;
  actual_date?: string | null;
  sort_order?: number;
  target_date?: string | null;
  days_remaining?: number | null;
  status?: string;
};

export default {
  async index(projectId: Id, packageId: Id) {
    return await api(
      route('api.v1.packages.procurement-steps.index', {
        project: projectId,
        package: packageId,
      }),
      'get',
    );
  },

  async update(projectId: Id, packageId: Id, steps: ProcurementStepRow[]) {
    return await api(
      route('api.v1.packages.procurement-steps.update', {
        project: projectId,
        package: packageId,
      }),
      'put',
      {
        data: { steps },
      },
    );
  },
};
